import { GUESS_EVENT_LIMIT, GUESS_EVENT_MAX_MS, type GuessViewEvent } from './types';

export function validGuessViewEvent(value: unknown): value is GuessViewEvent {
  if (!value || typeof value !== 'object') return false;
  const event = value as GuessViewEvent;
  return Object.keys(value).every(key => ['t', 'position', 'speed', 'playing'].includes(key))
    && Number.isSafeInteger(event.t) && event.t >= 0
    && Number.isFinite(event.position) && event.position >= 0 && event.position <= GUESS_EVENT_MAX_MS
    && Number.isFinite(event.speed) && event.speed > 0 && event.speed <= GUESS_EVENT_MAX_MS
    && typeof event.playing === 'boolean';
}

/** 坏回放数据只丢弃，不能影响判题。 */
export function sanitizeGuessViewEvents(value: unknown): GuessViewEvent[] {
  if (!Array.isArray(value)) return [];
  const result: GuessViewEvent[] = [];
  for (const event of value.slice(0, GUESS_EVENT_LIMIT)) {
    if (!validGuessViewEvent(event)) continue;
    if (result.length && event.t < result[result.length - 1].t) break;
    result.push({ ...event });
  }
  return result;
}

/** 从猜题时钟还原当时看到的画作位置；旧记录按首次默认自动播放回退。 */
export function guessViewAt(events: GuessViewEvent[] | undefined, elapsed: number, duration: number) {
  let view: GuessViewEvent = { t: 0, position: 0, speed: Math.max(1, duration / 10000), playing: true };
  let recorded = false;
  for (const event of events ?? []) {
    if (event.t > elapsed) break;
    view = event; recorded = true;
  }
  const position = Math.min(duration, Math.max(0, view.position + (view.playing ? Math.max(0, elapsed - view.t) * view.speed : 0)));
  return { position, recorded, playing: view.playing && position < duration, speed: view.speed };
}
